/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/extensions */
/* eslint-disable multiline-ternary */
import { Box, Button, Flex, Heading, Icon, Text } from '@chakra-ui/react'
import { format, startOfMonth, endOfMonth, parseISO, addDays, subMonths, addMonths } from 'date-fns'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { RiAddLine, RiFilter2Fill } from 'react-icons/ri'
import { CalendarSchedule } from '../../Components/CalendarSchedule'
import { Header } from '../../Components/Header'
import { FilterScheduleModal } from '../../Components/Modals/FilterScheduleModal'
import { Sidebar } from '../../Components/Sidebar'
import { IPropertiesProps } from '../../interfaces/IPropertiesProps'
import ISchedulesProps from '../../interfaces/ISchedulesProps'
import api from '../../Services/api'
import { SCHEDULES_STATUS } from '../../Services/contants'
import { Loader } from '../../Components/Loader'

const Schedule = () => {
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [data, setData] = useState<ISchedulesProps[]>([])
  const [error, setError] = useState(false)
  const [total, setTotal] = useState(10)
  const [houses, setHouses] = useState<IPropertiesProps[]>([])
  const [showModalFilter, setShowModalFilter] = useState(false)
  const [houseFiltered, setHouseFiltered] = useState<string[]>([])
  const [partnersFiltered, setPartnersFiltered] = useState<string[]>([])
  const [upcomingSchedulesFiltered, setUpcomingSchedulesFiltered] = useState(false)
  const [byCreatedAtFiltered, setByCreatedAtFiltered] = useState(false)
  const [startDate, setStartDate] = useState<string>('')
  const [endDate, setEndDate] = useState<string>('')
  const [byCheckInFiltered, setByCheckInFiltered] = useState(false)
  const [showNormalReservations, setShowNormalReservations] = useState(true)
  const [showSpecialReservations, setShowSpecialReservations] = useState(true)
  // Initialize dates with default 3-month range when component mounts
  useEffect(() => {
    if (!startDate && !endDate) {
      const { startDate: currentStartDate, endDate: currentEndDate } = getDefaultDateRange()
      setStartDate(currentStartDate)
      setEndDate(currentEndDate)
    }
  }, [])
  // Default range = mês anterior + atual + próximo (igual ao CalendarSchedule)
  const getDefaultDateRange = useCallback(() => {
    const now = new Date()
    const startDate = format(startOfMonth(subMonths(now, 1)), 'yyyy-MM-dd')
    const endDate = format(endOfMonth(addMonths(now, 1)), 'yyyy-MM-dd')
    return { startDate, endDate }
  }, [])

  const load = useCallback(async (pag: number, properties?: string[], partners?: string[], upcomingSchedules?: boolean, startDate?: string, endDate?: string, byCreatedAt?: boolean, byCheckIn?: boolean, showNormal?: boolean, showSpecial?: boolean) => {
    setLoading(true)
    try {
      const { data } = await api.get('/schedules', {
        params: {
          pag,
          all: true,
          property_id: properties,
          status: [SCHEDULES_STATUS.CREATED, SCHEDULES_STATUS.USED, SCHEDULES_STATUS.WAITING_CONFIRMATION],
          user_id: partners,
          greaterThanToday: upcomingSchedules,
          start_date: startDate,
          end_date: endDate,
          byCreatedAt: byCreatedAt,
          byCheckIn: byCheckIn,
          showNormal: showNormal ?? true,
          showSpecial: showSpecial ?? true
        }
      })

      console.log('data load: ', data)

      const normalize = data?.data?.map((schedule: ISchedulesProps) => {
        return {
          ...schedule,
          // date_initial: format(parseISO(data.checkIn), 'dd/MM/yyyy'),
          // date_final: addDays(parseISO(String(schedule.date_final)), 1),
        //   created_at: format(new Date(schedule.created_at), 'dd/MM/yyyy')
        }
      })

      console.log('normalize: ', normalize)

      setPage(pag)
      setData(normalize)
      setTotal(data.total)
    } catch (error) {
      console.log('erro ao pegar reservas: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  const loadProperties = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/properties', {
        params: {
          pag: 1,
          all: true
        }
      })

      setHouses(data?.data)
      setHouseFiltered(data?.data?.map((i: any) => i.id))
    } catch (error) {
      console.log('erro ao pegar reservas: ', error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    // Only load properties on mount, data will be loaded by CalendarSchedule component
    loadProperties()
  }, [])

  const legend = useMemo(() => {
    if (!data?.length) return [] // Retorna vazio se não houver dados

    const colors = data.reduce((acc: Array<{ name: string; color: string }>, appointment: ISchedulesProps) => {
      const { name, color } = appointment.property

      // Verifica se o item já existe no acumulador
      if (!acc.some(item => item.name === name && item.color === color)) {
        acc.push({ name, color })
      }

      return acc
    }, []) // Inicia o acumulador como um array vazio com o tipo correto

    return colors
  }, [data])

  const handleApplyFilters = useCallback(async ({ houses, partners, upcomingSchedules, byCreatedAt, startDate, endDate, byCheckIn, showNormal, showSpecial }: { houses: string[], partners: string[], upcomingSchedules: boolean, byCreatedAt : boolean, startDate: string, endDate: string, byCheckIn: boolean, showNormal: boolean, showSpecial: boolean }) => {

    setHouseFiltered(houses || [])
    setPartnersFiltered(partners || [])
    setUpcomingSchedulesFiltered(upcomingSchedules || false)
    setByCreatedAtFiltered(byCreatedAt || false)
    setStartDate(startDate || '')
    setEndDate(endDate || '')
    setByCheckInFiltered(byCheckIn || false)
    setShowNormalReservations(showNormal)
    setShowSpecialReservations(showSpecial)
    load(1, houses, partners, upcomingSchedules, startDate, endDate, byCreatedAt, byCheckIn, showNormal, showSpecial)
  }, [load])

  return (
    <Box> 
        <Header />
        {loading && <Loader />}

        {showModalFilter && <FilterScheduleModal open={showModalFilter} setOpen={() => setShowModalFilter(false)} houses={houses} onClose={() => setShowModalFilter(false)} onSubmit={handleApplyFilters} houseFiltered={houseFiltered} partnersFiltered={partnersFiltered} upcomingSchedulesFiltered={upcomingSchedulesFiltered} byCreatedAtFiltered={byCreatedAtFiltered} startDate={startDate} endDate={endDate} byCheckInFiltered={byCheckInFiltered} showNormalReservationsFiltered={showNormalReservations} showSpecialReservationsFiltered={showSpecialReservations} />}

        <Flex w="100%" my="6" maxWidth={1480} mx="auto" px={['4', '4', '6']}>
            {/* <Sidebar /> */}

            <Box flex="1" borderRadius={8} bg="white" p="8">
                    <Flex mb="8" justify="space-between" align="center">
                    <Heading size="lg" fontWeight="normal" color="green.dark">
                    Agenda

                    </Heading>

                    <Flex alignItems='center' gap='20px'>
                      <Button
                          onClick={() => setShowModalFilter(true)}
                          size="sm"
                          fontSize="sm"
                          bg="green.dark"
                          _hover={{ bgColor: 'green.light' }}
                          color="white"
                          leftIcon={<Icon as={RiFilter2Fill} fontSize="20" />}
                        >
                          Filtros
                      </Button>

                      <Button
                        as="a"
                        href="/schedule/create"
                        size="sm"
                        fontSize="sm"
                        bg="green.dark"
                        _hover={{ bgColor: 'green.light' }}
                        color="white"
                        leftIcon={<Icon as={RiAddLine} fontSize="20" />}
                        >
                        Novo Agendamento
                      </Button>
                    </Flex>
                </Flex>

         



                {!!data?.length && (
                   <Box>
                   <Text fontSize='19px' fontWeight='600'>Legendas:</Text>
                   <Flex mt='15px' mb='30px' flexWrap='wrap' gap='10px'>
                     {legend?.map(item => (
                       <Flex key={item.name} gap='10px' mr='20px' w='auto'>
                         <Box width='20px' height='20px' borderRadius='100%' backgroundColor={item.color} />
                         <Text>{item.name}</Text>
                       </Flex>
                     ))}
                   </Flex>
                 </Box>
                )}

                    <CalendarSchedule
                      schedule={data}
                      reloadFunction={(page = 1, properties, partners, upcomingSchedules, startDate, endDate, byCreatedAt, byCheckIn, showNormal, showSpecial) => {
                        void load(page, properties, partners, upcomingSchedules, startDate, endDate, byCreatedAt, byCheckIn, showNormal, showSpecial)
                      }}
                      currentFilters={{
                        properties: houseFiltered,
                        partners: partnersFiltered,
                        upcomingSchedules: upcomingSchedulesFiltered,
                        byCreatedAt: byCreatedAtFiltered,
                        byCheckIn: byCheckInFiltered,
                        showNormal: showNormalReservations,
                        showSpecial: showSpecialReservations,
                        startDate: startDate
                      }}
                    />

            </Box>
        </Flex>
    </Box>

  )
}

export { Schedule }
